export default __webpack_public_path__ + "static/media/iconCommentsBlackThin.6a630ddd.svg";